// tokenService.ts

import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

export interface ITokenService {
    getAccessToken(scopes: string[]): Promise<string | undefined>;
}

export const useTokenService = (): ITokenService => {
    const { instance, accounts } = useMsal();

    const getAccessToken = async (
        scopes: string[]
    ): Promise<string | undefined> => {
        try {
            const accessTokenResponse = await instance.acquireTokenSilent({
                scopes: scopes,
                account: accounts[0],
            });
            return accessTokenResponse.accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                await instance.acquireTokenRedirect({
                    scopes: scopes,
                    account: accounts[0],
                });
                // After redirect, the token will be acquired, so we can't return a value here.
            } else {
                console.error(error);
            }
            // Return undefined explicitly because of error or redirect
            return undefined;
        }
    };

    return { getAccessToken };
};
